import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "product-category-detail" }
const _hoisted_2 = { class: "detail-header" }
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "info-block" }
const _hoisted_5 = { class: "info-left" }
const _hoisted_6 = { class: "info-row" }
const _hoisted_7 = { class: "info-right" }
const _hoisted_8 = { class: "info-card" }
const _hoisted_9 = { class: "info-img" }
const _hoisted_10 = { class: "info-table" }
const _hoisted_11 = { class: "info-row" }
const _hoisted_12 = { class: "info-value" }
const _hoisted_13 = { class: "info-row" }
const _hoisted_14 = { class: "info-value" }
const _hoisted_15 = { class: "model-panel" }
const _hoisted_16 = { class: "model-search-bar" }
const _hoisted_17 = { class: "model-btn-bar" }
const _hoisted_18 = { class: "model-table-bar" }
const _hoisted_19 = { class: "table-tools" }
const _hoisted_20 = {
  class: "lowcode-bar",
  style: {"margin-bottom":"16px"}
}
const _hoisted_21 = { style: {"text-align":"center","padding":"32px 0"} }

import { ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { EditOutlined } from '@ant-design/icons-vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductCategoryDetail',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const tabKey = ref('info')

// 模拟数据，实际可根据route.params.id请求
const detail = ref({
  name: '传感器设备',
  desc: '传感器相关设备',
  image: ''
})

function goEdit() {
  // 编辑逻辑
}

function goLowcode() {
  router.push('/lowcode')
}

const modelColumns = [
  { title: '功能类型', dataIndex: 'type', key: 'type' },
  { title: '功能名称', dataIndex: 'name', key: 'name' },
  { title: '标识符', dataIndex: 'identifier', key: 'identifier' },
  { title: '数据类型', dataIndex: 'dataType', key: 'dataType' },
  { title: '读写类型', dataIndex: 'accessType', key: 'accessType' },
  { title: '数据定义', dataIndex: 'definition', key: 'definition' },
  { title: '操作', key: 'action' }
]

const selectedKeys = ref(['sync'])
const openKeys = ref(['system'])

function onMenuSelect({ key }: { key: string }) {
  selectedKeys.value = [key]
  if (key === 'feedback') router.push('/system/systemConfig/feedback')
  if (key === 'user-mgr') router.push('/system/systemConfig/user-mgr')
  if (key === 'sync') router.push('/system/systemConfig/sync')
  // 其它菜单可按需跳转
}

return (_ctx: any,_cache: any) => {
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_card, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_a_tag, {
              color: "#1677ff",
              style: {"font-size":"16px"}
            }, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("产品品类详情")
              ])),
              _: 1
            })
          ])
        ]),
        _createVNode(_component_a_tabs, {
          activeKey: tabKey.value,
          "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((tabKey).value = $event)),
          style: {"margin-top":"12px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "info",
              tab: "产品品类信息"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["tab-btn", {active: tabKey.value==='info'}])
                      }, _toDisplayString(detail.value.name), 3)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_button, {
                      type: "default",
                      onClick: goEdit,
                      style: {"margin-left":"16px"}
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_unref(EditOutlined))
                      ]),
                      default: _withCtx(() => [
                        _cache[2] || (_cache[2] = _createTextVNode("编辑"))
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_image, {
                      width: 120,
                      height: 120,
                      preview: false,
                      src: "https://img.icons8.com/ios/100/000000/image.png"
                    })
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[3] || (_cache[3] = _createElementVNode("span", { class: "info-label" }, "产品品类名称", -1)),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(detail.value.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _cache[4] || (_cache[4] = _createElementVNode("span", { class: "info-label" }, "描述", -1)),
                      _createElementVNode("span", _hoisted_14, _toDisplayString(detail.value.desc), 1)
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_a_tab_pane, {
              key: "model",
              tab: "物模型"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form, { layout: "inline" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, { label: "标识符" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input, {
                              placeholder: "请输入标识符",
                              style: {"width":"180px"}
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, { label: "类型" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              placeholder: "请选择类型",
                              style: {"width":"120px"}
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_select_option, { value: "" }, {
                                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                                    _createTextVNode("全部")
                                  ])),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_form_item, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              style: {"margin-right":"8px"}
                            }, {
                              default: _withCtx(() => _cache[6] || (_cache[6] = [
                                _createTextVNode("查询")
                              ])),
                              _: 1
                            }),
                            _createVNode(_component_a_button, null, {
                              default: _withCtx(() => _cache[7] || (_cache[7] = [
                                _createTextVNode("重置")
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_a_button, { type: "primary" }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode("快捷标准功能")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "primary" }, {
                      default: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createTextVNode("批量删除")
                      ])),
                      _: 1
                    }),
                    _createVNode(_component_a_button, { type: "primary" }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode("全部物模型")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createVNode(_component_a_button, { type: "text" }, {
                        icon: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createElementVNode("i", { class: "fa fa-refresh" }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_button, { type: "text" }, {
                        icon: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createElementVNode("i", { class: "fa fa-th-large" }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_button, { type: "text" }, {
                        icon: _withCtx(() => _cache[13] || (_cache[13] = [
                          _createElementVNode("i", { class: "fa fa-list" }, null, -1)
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_a_button, { type: "text" }, {
                        icon: _withCtx(() => _cache[14] || (_cache[14] = [
                          _createElementVNode("i", { class: "fa fa-expand" }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(_component_a_button, {
                      type: "primary",
                      onClick: goLowcode
                    }, {
                      default: _withCtx(() => _cache[15] || (_cache[15] = [
                        _createTextVNode("低代码")
                      ])),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_a_table, {
                    columns: modelColumns,
                    "data-source": [],
                    pagination: false,
                    style: {"margin-top":"8px"}
                  }, {
                    emptyText: _withCtx(() => [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_a_empty, { description: "暂无数据" })
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["activeKey"])
      ]),
      _: 1
    })
  ]))
}
}

})